import application from 'stimulus_application';
import { definitionsFromContext } from 'stimulus/webpack-helpers';
import './itinerary-card-slider.scss';
import './itinerary-card.scss';

const context = require.context('./', true, /_controller\.js$/);
application.load(definitionsFromContext(context));
